import { useState, useEffect } from "react";
import React from "react";
import { sendAppierConversion } from "../tracking/appier";
import { trackButtonClick, parseCurrentUriAds } from "../tracking/tracker";

const defaultLinks = {
  line: "line://app/2007605903-BR0b43NW?_ads=Home_contact_line",
  web: "https://play.bwd.tw/?_ads=Home_contact_web",
  services: "/services",
  privacy: "/privacy",
  gamerule: "/gamerule",
};

export const Contact = (props) => {
  const [links, setLinks] = useState({
    ...defaultLinks,
    ...(props.data || {}),
  });

  // 當 props.data 改變時覆蓋預設值
  useEffect(() => {
    setLinks((prev) => ({
      ...prev,
      ...(props.data || {}),
    }));
  }, [props.data]);

  // 自動注入 ads 到所有 links
  useEffect(() => {
    const { ads, ref } = parseCurrentUriAds();

    if (ads || ref) {
      setLinks((prevLinks) => {
        const updated = {};

        Object.keys(prevLinks).forEach((key) => {
          let url;

          try {
            // 如果是完整網址
            url = new URL(prevLinks[key]);
          } catch (e) {
            // 如果是相對路徑，補上 origin
            url = new URL(prevLinks[key], window.location.origin);
          }

          // 分開 set → 不會被 encode 成怪字串
          if (ads) url.searchParams.set("_ads", ads);
          if (ref) url.searchParams.set("ref", ref);

          updated[key] = url.toString();
        });

        return updated;
      });
    }
  }, []);  

  return (
    <div>
      <div id="contact">
        <div className="container text-center">
          <div className="col-md-8 col-md-offset-2 contact-info">
            <div className="row">
              <div className="col-md-6 col-xs-6">
                <a id="btn-contact-line" href={links.line} className="btn page-scroll" onClick={(e) => {
                  sendAppierConversion("Conversion_2484");
                  trackButtonClick(e.currentTarget);
                }}>
                  <img src="img/btn-line.png" className=" " alt="點LINE立即玩" />
                </a>{" "}
              </div>
              <div className="col-md-6 col-xs-6">
                <a id="btn-contact-web" href={links.web} className="btn page-scroll" onClick={(e) => {
                  sendAppierConversion("Conversion_86ab");
                  trackButtonClick(e.currentTarget);
                }}>
                  <img src="img/btn-web.png" className=" " alt="點網頁立即玩" />
                </a>{" "}
              </div>
            </div>
            <div className="contact-text">
              <p>{props.data ? props.data.p1 : "loading"}</p>
              <p>{props.data ? props.data.p2 : "loading"}</p>
            </div>
            <div className="col-md-12 col-xs-12 contact-img">
              <img src="img/logo.png" className=" " alt="" />
              <img src="img/contact-mycard.jpg" className=" " alt="" />
              <img src="img/contact-18up.jpg" className=" " alt="" />
            </div>
          </div>
          <div className="col-md-8 col-md-offset-2 contact-icon-area">
            <div className="row">
              <div className="col-md-3 col-xs-6">
                <div className="contact-icon">
                  <div className="contact-icon-image">
                    <img src="img/contact-icon-maintains.png" className="" alt="" />
                  </div>
                  <div className="contact-icon-meta">
                    <p>
                      客服服務<br></br>
                      周一到周五
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-xs-6">
                <div className="contact-icon">
                  <div className="contact-icon-image">
                    <img src="img/contact-icon-services.png" className="" alt="" />
                  </div>
                  <div className="contact-icon-meta">
                    <p>
                      服務時間<br></br>
                      10:00~22:00
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-xs-6">
                <div className="contact-icon">
                  <div className="contact-icon-image">
                    <img src="img/contact-icon-line.png" className="" alt="" />
                  </div>
                  <div className="contact-icon-meta">
                    <p>
                      官方Line<br></br>
                      <a id="LineAT" href="https://line.me/ti/p/@BWD88" onClick={(e) => {
                        trackButtonClick(e.currentTarget);
                      }}>@BWD88</a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-xs-6">
                <div className="contact-icon">
                  <div className="contact-icon-image">
                    <img src="img/contact-icon-mail.png" className="" alt="" />
                  </div>
                  <div className="contact-icon-meta">
                    <p>
                      客服信箱<br></br>
                      service@bwd.tw
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="contact-privacy">
                <ul>
                  <li>
                    <a href={links.services} target="blank">
                      <span>服務條款</span>
                    </a>
                  </li>
                  <li>|</li>
                  <li>
                    <a href={links.privacy} target="blank">
                      <span>隱私政策</span>
                    </a>
                  </li>
                  <li>|</li>
                  <li>
                    <a href={links.gamerule} target="blank">
                      <span>遊戲規章</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>© 2022 All right reserved 定城實業有限公司 版權所有</p>
        </div>
      </div>
    </div>
  );
};